// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1hIgS","range":"MonthRangeSwitch_range__Nl2GT","disabled":"MonthRangeSwitch_disabled__YH2Td"};